import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const ApplicationsCTA = () => {
  return (
    <Box id="apply" sx={{ py: 6, textAlign: 'center' }}>
      <Typography variant="h4" sx={{ fontWeight: 700 }} gutterBottom>
        Applications Open
      </Typography>
      <Typography variant="h6" color="text.secondary" paragraph>
        We work with companies where we can deliver a clear competitive advantage.
        If that sounds like you, apply to work with us.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        size="large"
        component="a"
        href="/contact"
      >
        Apply Now
      </Button>
    </Box>
  );
};

export default ApplicationsCTA;


